import { useState, useEffect } from "react";
import { getMyKybRequests } from "../services/kybService";

const OPEN_STATUSES = [
  "submitted",
  "awaiting_directors",
  "ready_for_admin",
  "admin_in_progress",
];

/**
 * Hook to fetch the current user's KYB application status.
 *
 * Returns:
 *  - status: "none" | "pending" | "approved" | "error" | null (loading)
 *  - isLoading: boolean
 */
export function useKybStatus() {
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchStatus() {
      try {
        const result = await getMyKybRequests();
        if (cancelled) return;

        const requests = result?.data?.requests || [];
        if (requests.length === 0) {
          setStatus("none");
          return;
        }

        // Explicitly sort by createdAt descending to get the most recent request
        const sorted = [...requests].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        const latest = sorted[0];

        if (latest.status === "approved") {
          setStatus("approved");
        } else if (OPEN_STATUSES.includes(latest.status)) {
          setStatus("pending");
        } else {
          setStatus("none");
        }
      } catch {
        if (!cancelled) setStatus("error");
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    fetchStatus();
    return () => {
      cancelled = true;
    };
  }, []);

  return { status, isLoading };
}
